import React from "react";
import "./Footer.css";
import packageJson from "../../../../package.json";
import serviceImg from "../../../img/login/Un servicio de MEI.png";

const Footer = (props) => {
  return (
    <div className="container-footer">
      <div className="row no-margin p-grid">
        <div className="relative_div p-col-4 p-sm-4 p-md-4 no-padding-l">
          <div className="logo-footer">
            <img
              alt="lightBulb"
              src={serviceImg}
            />
          </div>
        </div>
        <div className="p-col-8 p-sm-8 p-md-8 no-padding-r">
          <p
            style={{
              color: "#21A390",
              fontSize: "15px",
              maxWidth: "100%",
              maxHeight: "100%",
              textAlign: "right",
            }}
          >
            CONTACTO
          </p>
          <p
            style={{
              color: "white",
              fontSize: "15px",
              maxWidth: "100%",
              maxHeight: "100%",
              textAlign: "right",
            }}
          >
            C. meipresval@mei.com.mx
            <br />
            T. +52 (55) 5284 9200
          </p>
          <p
            style={{
              color: "white",
              fontSize: "15px",
              maxWidth: "100%",
              maxHeight: "100%",
              textAlign: "right",
            }}
          >
            Versión: {props.version} ({packageJson.version})
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
